// The stat bar's numbers (backlog b29bf95c, Oct 17: Felipe said build it now,
// each number showing only once it is believable). public_site_stats()
// counts them per market (scripts/migrate/new-project-site-stats-2026-10-17.sql);
// the labels are Site copy keys stats.* that Angelina edits live.

export interface SiteStats {
  /** Homes renters can see in this market. */
  homes: number;
  /** This market's areas with at least one of those homes. */
  areas: number;
  /** Renter requests an owner answered in the last 90 days. */
  answered90d: number;
}

export type StatKey = keyof SiteStats;

/** Below these a number reads as small, not as proof: it stays hidden. */
export const STAT_MIN: Record<StatKey, number> = { homes: 20, areas: 3, answered90d: 10 };

export const STAT_COPY_KEY: Record<StatKey, string> = {
  homes: "stats.homes",
  areas: "stats.areas",
  answered90d: "stats.answered",
};

const ORDER: StatKey[] = ["homes", "areas", "answered90d"];

/** The RPC's JSON as plain numbers (prerendered pages embed it as JSON). */
export function toSiteStats(raw: unknown): SiteStats | null {
  if (!raw || typeof raw !== "object") return null;
  const r = raw as Record<string, unknown>;
  const n = (v: unknown) => (typeof v === "number" && Number.isFinite(v) ? v : Number(v) || 0);
  return { homes: n(r.homes), areas: n(r.areas), answered90d: n(r.answered90d) };
}

/** The numbers worth showing, in page order. Empty means no bar. */
export function visibleStats(s: SiteStats | null | undefined): { key: StatKey; value: number }[] {
  if (!s) return [];
  return ORDER.filter((k) => s[k] >= STAT_MIN[k]).map((k) => ({ key: k, value: s[k] }));
}
